'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSchemaMap = createSchemaMap;

var _propTypes = require('prop-types');

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _merge = require('lodash/fp/merge');

var _merge2 = _interopRequireDefault(_merge);

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _QueryEditor = require('./QueryEditor');

var _QueryEditor2 = _interopRequireDefault(_QueryEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addSchemaMap(lastKeys, schema) {
  var contents = schema.contents;

  var map = {};
  Object.keys(contents).forEach(function (k) {
    var tmpContents = contents[k].contents;
    var innerContents = Array.isArray(tmpContents) ? tmpContents[0].contents : tmpContents;
    var key = lastKeys ? lastKeys + '.' + k : k;
    if (innerContents) {
      Object.assign(map, addSchemaMap(key, contents[k]));
    } else {
      map[key] = { schema: contents[k] };
    }
  });
  return map;
}

function createSchemaMap(schema) {
  return addSchemaMap('', schema);
}

var QueryEditor = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  schema: _propTypes.object.isRequired,
  setting: _propTypes.object,
  fields: _propTypes.array
}), (0, _withProps2.default)(function (_ref) {
  var fields = _ref.fields;
  return {
    fields: fields.map(function (f) {
      return Array.isArray(f) ? f.join('.') : f;
    })
  };
}), (0, _flattenDefaultProp2.default)('setting'), (0, _withPropsOnChange2.default)(['schema', 'setting'], function (_ref2) {
  var schema = _ref2.schema,
      _ref2$editorByKey = _ref2.editorByKey,
      editorByKey = _ref2$editorByKey === undefined ? {} : _ref2$editorByKey;
  return {
    conditionSpecByKey: (0, _merge2.default)(
    // mapValues(fieldSchema => ({ schema: fieldSchema }))(schema.contents),
    createSchemaMap(schema), (0, _mapValues2.default)(function (Editor) {
      return { Editor: Editor };
    })(editorByKey))
  };
}), (0, _exposeProps2.default)(['conditionSpecByKey', 'fields']))(_QueryEditor2.default);

QueryEditor.displayName = 'QueryEditor';

exports.default = QueryEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/index.js
// module id = 1715
// module chunks = 0